module.exports = __webpack_public_path__ + "assets/dc497412a0526c3d0c7b6d78edefa9e9.json";